module.exports = __webpack_public_path__ + "static/media/whatsapp.87c2679f.svg";